import React, { useState } from 'react'
import propTypes from "prop-types"

const AgeCalculator = ({calculateAge}) => {
    const[birth,setBirth]=useState("")
    console.log(birth)

    const handlechangedate=(e)=>{
        setBirth(e.target.value)
     
    }
    const handleSubmit=(e)=>{
        e.preventDefault()
        calculateAge(birth)
    }

  return (
     
    <div>
    <form onSubmit={handleSubmit} className="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
      <input className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" value={birth} type="date"  onChange={handlechangedate}  />
      <button className="text-gray-900 bg-gradient-to-r from-teal-200 to-lime-200 hover:bg-gradient-to-l hover:from-teal-200 hover:to-lime-200 focus:ring-4 focus:outline-none focus:ring-lime-200 dark:focus:ring-teal-700 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"  type='submit'   disabled={!birth} >Age Calculate</button>
      </form>
      </div>
  )
}
AgeCalculator.prototype={
calculateAge: propTypes.func.isRequired
}

export default AgeCalculator
